import {
  FETCH_DEDUCTMONEY,
  FETCH_DEDUCTMONEY_SUCCESS,
  FETCH_DEDUCTMONEY_FAILED,
} from "../store/types";

const INITIAL_STATE = {
  deductmoneys: null,
  loading: false,
  error: {
    flag: false,
    msg: null
  }
}

export const deductmoneyreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_DEDUCTMONEY:
      return {
        ...state,
        loading: true
      };
    case FETCH_DEDUCTMONEY_SUCCESS:
      return {
        ...state,
        deductmoneys: action.payload,
        loading: false
      };
    case FETCH_DEDUCTMONEY_FAILED:
      return {
        ...state,
        deductmoneys: null,
        loading: false,
        error: {
          flag: true,
          msg: action.payload
        }
      };
    default:
      return state;
  }
};


